import { useAtom } from 'jotai';
import { addChildMutationAtom } from '@/features/shared/features/addOrEditChild/model';

export const useAddChild = () => {
    const [{ mutate, status, reset, error }] = useAtom(addChildMutationAtom);

    // Return the mutation state and trigger function
    return {
        mutate, // This will trigger the mutation
        status,
        reset,
        errorMessage: error instanceof Error ? error.message : null,
    };
};
